// Copyright (c) Docugami, Inc. All rights reserved.

import { AssistedAuthoringCanvas } from "components/work_path/AssistedAuthoringCanvas";
import { ReportDesignerCanvas } from "components/work_path/ReportDesignerCanvas";
import { WorkPathType } from "networking/WorkPathApi";
import { WorkPath } from "networking/WorkPathApi";

export interface WorkPathCanvasProps {
    workPath: WorkPath;
    documentContext: DocumentContext
}

export interface DocumentContext {
    documentId: string;
    instanceId: string;
}

export const WorkPathCanvas = (props: WorkPathCanvasProps): JSX.Element => {
    switch (props.workPath.workPathType) {
        case WorkPathType.AssistedAuthoring:
            return <AssistedAuthoringCanvas {...props} />;
        default:
            // todo: fix this
            return <ReportDesignerCanvas {...props} lastDocumentId="" setLastDocument={() => {}} />;
    }
}
